// Enum for PlanogramVisual component mode
export const PlanogramVisualMode = Object.freeze({
    NEW: 'NEW',
    EDIT: 'EDIT'
});
